import { auth } from '../firebase/config';

const FUNCTIONS_BASE_URL =
  import.meta.env.VITE_FUNCTIONS_BASE_URL ||
  'https://europe-west3-mintleaf-74d27.cloudfunctions.net';

export class GuestReservationNetworkError extends Error {
  constructor(message: string, public readonly causeError?: unknown) {
    super(message);
    this.name = 'GuestReservationNetworkError';
  }
}


export type GuestModificationRejectionPolicy = 'keep_original' | 'cancel_original';

export type GuestModifyReservationPayload = {
  unitId: string;
  reservationId: string;
  manageToken: string;
  headcount: number;
  startTimeMs: number;
  endTimeMs: number;
  rejectionPolicy?: GuestModificationRejectionPolicy;
  expectedOriginal?: { headcount: number; startTimeMs: number; endTimeMs: number };
};

export type GuestModifyReservationResponse = {
  ok?: true;
  mode?: 'pending_modification_request' | string;
  pendingModificationId?: string;
  headcount?: number;
  startTimeMs?: number;
  endTimeMs?: number;
};

export type ReservationKind = 'standard' | 'manual' | 'special_event';
export type ReservationBypassedConstraint = 'missing_email' | 'missing_phone' | 'booking_window' | 'opening_hours' | 'party_size' | 'capacity';

export type GuestCreateReservationPayload = {
  unitId: string;
  dateKey: string;
  bookingFlowAnalytics?: {
    visitorId: string;
    sessionId: string;
    bookingFlowId: string;
    submitAttemptId: string;
    replayCredential?: string;
  };
  reservation: {
    termsFingerprint?: string;
    unitId: string;
    name: string;
    headcount: number;
    startTime: string;
    endTime: string;
    contact: {
      phoneE164: string;
      email: string;
    };
    locale?: 'hu' | 'en';
    status?: 'confirmed' | 'pending';
    reservationMode?: 'auto' | 'request';
    occasion?: string;
    source?: string;
    preferredTimeSlot?: string | null;
    seatingPreference?: 'any' | 'bar' | 'table' | 'outdoor' | 'terrace';
    customData?: Record<string, string>;
    reservationKind?: ReservationKind;
    sendConfirmationEmail?: boolean;
    override?: {
      enabled?: boolean;
      reason?: string;
      bypassedConstraints?: ReservationBypassedConstraint[];
    };
  };
};

export type GuestCreateReservationResponse = {
  bookingId: string | null;
  manageToken?: string;
  capacityRemaining?: number | null;
  allocationDecision?: unknown;
  adminActionToken?: string | null;
  emailQueued?: boolean;
  emailExpected?: boolean;
  guestEmailQueued?: boolean;
  adminEmailQueued?: boolean;
  emailSkipReason?: string;
};

export const guestCreateReservation = async (
  payload: GuestCreateReservationPayload
): Promise<{ ok: true; data: GuestCreateReservationResponse } | { ok: false; status: number; data: any }> => {
  let response: Response;
  try {
    const reservationKind = payload.reservation?.reservationKind ?? 'standard';
    const token = reservationKind === 'standard'
      ? null
      : await auth.currentUser?.getIdToken();
    response = await fetch(`${FUNCTIONS_BASE_URL}/guestCreateReservation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    throw new GuestReservationNetworkError(
      'Network/CORS hiba a guestCreateReservation hívásnál',
      error
    );
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    console.error('guestCreateReservation http error', {
      status: response.status,
      body: data,
    });
    return { ok: false, status: response.status, data };
  }
  return { ok: true, data };
};
